import { render, staticRenderFns } from "./MoonDayCTA.vue?vue&type=template&id=195ae26d&scoped=true&"
import script from "./MoonDayCTA.vue?vue&type=script&lang=js&"
export * from "./MoonDayCTA.vue?vue&type=script&lang=js&"
import style0 from "./MoonDayCTA.vue?vue&type=style&index=0&id=195ae26d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195ae26d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('195ae26d')) {
      api.createRecord('195ae26d', component.options)
    } else {
      api.reload('195ae26d', component.options)
    }
    module.hot.accept("./MoonDayCTA.vue?vue&type=template&id=195ae26d&scoped=true&", function () {
      api.rerender('195ae26d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/星盤組件/MoonDayCTA.vue"
export default component.exports